import axios from '../config/axiosPrivate';

export const uploadEmailMatchingZip = async (zipFile: File) => {
  const url = '/email_matching/upload-zip';
  const formData = new FormData();
  formData.append('zip_file', zipFile);

  const response = await axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

export const getEmailMatchingRecords = async (
  params: {
    page?: number;
    page_size?: number;
    search?: string;
    status__in?: number[];
    source__in?: number[];
    communication_types__overlap?: number[];
    confidence_range?: number[];
    confirmed_by__in?: number[];
  } = {}
) => {
  const url = '/email_matching/';
  const response = await axios.get(url, {
    params,
    paramsSerializer: {
      indexes: null,
    },
  });
  return response.data;
};

export const getEmailMatchingRecord = async (recordId: number) => {
  const url = `/email_matching/${recordId}`;
  const response = await axios.get(url);
  return response.data;
};

export const updateEmailMatchingRecordStatus = async (recordId: number, status: number) => {
  const url = `/email_matching/${recordId}/status`;
  const response = await axios.patch(url, { status });
  return response.data;
};

export const confirmEmailMatchingRecordMatch = async (
  recordId: number,
  payload: {
    matched_community?: number | null;
    sender_type?: number | null;
    delivery_method?: number | null;
    communication_types?: number[];
  }
) => {
  const url = `/email_matching/${recordId}/confirm-match`;
  const response = await axios.patch(url, payload);
  return response.data;
};

export const getEmailMatchingTabsMetrics = async (
  params: {
    search?: string;
    source__in?: number[];
    communication_types__overlap?: number[];
    confidence_range?: number[];
    confirmed_by__in?: number[];
  } = {}
) => {
  const url = '/email_matching/tabs-metrics';
  const response = await axios.get(url, {
    params,
    paramsSerializer: {
      indexes: null,
    },
  });
  return response.data;
};

export const getEmailMatchingReviewers = async () => {
  const url = '/email_matching/reviewers';
  const response = await axios.get(url);
  return response.data;
};
